import { createSlice } from "@reduxjs/toolkit";
import { moduleApiSlice } from "./moduleApiSlice";
import { createSelector } from "@reduxjs/toolkit";

const initialState = {
  one: {
    module_name: "",
    description: "",
    path: [],
  },
  access: {
    Access: [],
    Module: {
      path: [],
    },
    Roles: [],
  },
  query: {},
};

export const moduleSlice = createSlice({
  name: "module",
  initialState: initialState,
  reducers: {
    setQueryValue: (state, action) => {
      if (action.payload.key) {
        state.query[action.payload.key] = action.payload.value;
      } else {
        state.query = action.payload;
      }
    },
    setOneValue: (state, action) => {
      state.one[action.payload.key] = action.payload.value;
    },
    setAccessType: (state, action) => {
      state.one.path[action.payload.index][action.payload.key] =
        action.payload.value;
    },
    setAdminRoutes: (state, action) => {
      state.one.path[action.payload.index].admin_routes[
        action.payload.adminIndex
      ] = action.payload.value;
    },
    setServerRoutes: (state, action) => {
      state.one.path[action.payload.index].server_routes[
        action.payload.serverIndex
      ][action.payload.serverKey] = action.payload.value;
    },
    deleteAccessType: (state, action) => {
      state.one.path = state.one.path.filter(
        (each, idx) => idx !== action.payload.index
      );
    },
    deleteClientRoute: (state, action) => {
      state.one.path[action.payload.index].admin_routes = state.one.path[
        action.payload.index
      ].admin_routes.filter((each, idx) => idx !== action.payload.adminIndex);
    },
    deleteServerRoute: (state, action) => {
      state.one.path[action.payload.index].server_routes = state.one.path[
        action.payload.index
      ].server_routes.filter((each, idx) => idx !== action.payload.serverIndex);
    },
    addAccessType: (state) => {
      state.one.path = [
        ...state.one.path,
        {
          access_type: "",
          admin_routes: [],
          server_routes: [],
          access_type_description: "",
        },
      ];
    },
    addClientRoute: (state, action) => {
      state.one.path[action.payload.index].admin_routes = [
        ...state.one.path[action.payload.index].admin_routes,
        "",
      ];
    },
    addServerRoute: (state, action) => {
      state.one.path[action.payload.index].server_routes = [
        ...state.one.path[action.payload.index].server_routes,
        {
          route: "",
          method: "GET",
        },
      ];
    },
    clearOne: (state) => {
      state.one = initialState.one;
    },
    updateAccess: (state, action) => {
      const pathIndex = action.payload.module_id.indexOf(
        action.payload.singlePath
      );
      if (pathIndex > -1) {
        action.payload.module_id.splice(pathIndex, 1);
      } else {
        action.payload.module_id.push(action.payload.singlePath);
      }

      let tempAccess = [...state.access.Access];
      const index = tempAccess.findIndex(
        (each) =>
          each.module_id === action.payload.ModuleId &&
          each.role_id === action.payload.roleId
      );
      if (index > -1) {
        tempAccess[index].access_type = action.payload.module_id;
      } else {
        tempAccess = [
          ...tempAccess,
          {
            access_type: action.payload.module_id,
            module_id: action.payload.ModuleId,
            role_id: action.payload.roleId,
          },
        ];
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        moduleApiSlice.endpoints.loadOneModule.matchFulfilled,
        (state, action) => {
          state.loading = false;
          state.one = action.payload.data;
        }
      )
      .addMatcher(
        moduleApiSlice.endpoints.saveModule.matchFulfilled,
        (state) => {
          state.one = initialState.one;
        }
      )
      .addMatcher(
        moduleApiSlice.endpoints.loadAccessModule.matchFulfilled,
        (state, action) => {
          state.access = action.payload.data;
        }
      )
      .addMatcher(
        moduleApiSlice.endpoints.saveAccess.matchFulfilled,
        (state) => {
          state.access = initialState.access;
        }
      );
  },
});

export const {
  setQueryValue,
  setOneValue,
  setAccessType,
  setAdminRoutes,
  setServerRoutes,
  deleteAccessType,
  deleteClientRoute,
  deleteServerRoute,
  addAccessType,
  addClientRoute,
  addServerRoute,
  clearOne,
  updateAccess,
} = moduleSlice.actions;

export default moduleSlice.reducer;

export const selectDomain = (state) => state.module || initialState;

export const makeSelectQuery = createSelector(
  selectDomain,
  (state) => state.query
);
